import React from 'react'
import { GoogleMap, LoadScript } from '@react-google-maps/api';

const containerStyle = {
  width: '90%',
  height: '280px',
  margin:'0 auto 50px auto',
};

const center = {
  lat: 30.332184,
  lng: -81.655647
};

function Map() {
  const [map, setMap] = React.useState(null)

  const onLoad = React.useCallback(function callback(map) {
    map.setCenter(center);
    setMap(map)
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  return (
    <LoadScript
      googleMapsApiKey="AIzaSyB6T_rF-Udcg4oSlJEYM70mf37uFhu3-0g"
    >
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={8}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        { }
        <></>
      </GoogleMap>
    </LoadScript>
  )
}

export default React.memo(Map)
